import React, { useEffect, useState } from 'react'
import Fillter from '../../Fillter'
import Select from "react-select"
import axios from 'axios';

const MemberShipFilter = ({ setDataFillterout }) => {

    const [datafiler, setDatafiler] = useState([]);
    const [dataFillter, setDataFillter] = useState({
        "memberNumber": ""
    })
    const GET_Filter = 'admin/qualification/get_all_members_numbers'
    useEffect(() => {
        const getDFilter = async () => {

            await axios.get(GET_Filter, {
            })
                .then(response => {
                    setDatafiler(response?.data)

                })

        }
        getDFilter()
    }, [])

    
    const restart = async () => {
        setDataFillter(
            {
                "memberNumber": ""
            }
        )
        setDataFillterout({ "memberNumber": "" })
        // await getPaying_customersFilter()
    }






    const handleChange = (selectedOption, name,) => {
        console.log(selectedOption)
        // const { name } = e.name;
        setDataFillter({
            // ...dataFillter,
            [name]: selectedOption?.value
            ,
        })



    }


    const actionFilter = () => {
        setDataFillterout(dataFillter)
    }


    return (
        <Fillter actionFilter={actionFilter} restart={restart}>
            <div className='flex justify-end items-center'>
                <Select className='border border-black w-2/3 text-right '
                    type="text"
                    id="memberNumber "
                    name="memberNumber"
                    value={dataFillter?.memberNumber?
                        { value: dataFillter.memberNumber, label: dataFillter.memberNumber } : null}
                    onChange={(e) => handleChange(e, 'memberNumber')}
                    options={datafiler?.map((item) => { return { value: item, label: item } })}
                    placeholder="...חפש"
                    isClearable
                    isSearchable

                    maxMenuHeight={100}
                />


                <label className='ml-3 w-1/6' htmlFor="member_number">מספר חבר</label>
            </div>
        </Fillter>
    )
}

export default MemberShipFilter